"use client"

import * as React from "react"

export type LeoThreadCatalogState = {
  frozen: boolean
  appliedAlternateId: string | null
  /** Hero apply beat: thread owns thinking; catalog stays untouched. */
  applyBeat: boolean
  /** Pager card body skeleton while apply advances to the next row. */
  pagerLoading: boolean
}

const LeoThreadCatalogContext = React.createContext<LeoThreadCatalogState>({
  frozen: false,
  appliedAlternateId: null,
  applyBeat: false,
  pagerLoading: false,
})

/** Ask Leo thread: suggestion cards stay visible; one set shows as selected. */
export function LeoThreadCatalogFrozen({
  frozen,
  appliedAlternateId = null,
  applyBeat = false,
  pagerLoading = false,
  children,
}: {
  frozen: boolean
  appliedAlternateId?: string | null
  applyBeat?: boolean
  pagerLoading?: boolean
  children: React.ReactNode
}) {
  const value = React.useMemo(
    () => ({
      frozen,
      appliedAlternateId: appliedAlternateId ?? null,
      applyBeat,
      pagerLoading,
    }),
    [applyBeat, appliedAlternateId, frozen, pagerLoading],
  )
  return (
    <LeoThreadCatalogContext.Provider value={value}>
      {children}
    </LeoThreadCatalogContext.Provider>
  )
}

export function useLeoThreadCatalogState() {
  return React.useContext(LeoThreadCatalogContext)
}

/** @deprecated Use useLeoThreadCatalogState */
export function useLeoThreadCatalogFrozen() {
  return useLeoThreadCatalogState().frozen
}
